import React, { useState } from 'react';

function JourneyFaqPanel({ faqs, travelerFaqs }) {
	const all = [
		...(faqs || []).map((f) => ({ ...f, category: 'general' })),
		...(travelerFaqs || []),
	];
	const categories = [...new Set(all.map((f) => f.category || 'general'))];
	const [filter, setFilter] = useState('all');
	const shown = filter === 'all' ? all : all.filter((f) => (f.category || 'general') === filter);

	return (
		<div className="guided-panel">
			<h3 className="guided-panel__title">Frequently asked questions</h3>
			<p className="guided-panel__intro">Collected from real EBC travelers — official sources cited where applicable.</p>
			<div className="guided-faq__filters">
				<button type="button" className={filter === 'all' ? 'is-active' : ''} onClick={() => setFilter('all')}>All</button>
				{categories.map((c) => (
					<button key={c} type="button" className={filter === c ? 'is-active' : ''} onClick={() => setFilter(c)}>{c}</button>
				))}
			</div>
			<div className="guided-faq__list">
				{shown.map((f) => (
					<details key={f.q} className="guided-faq__item">
						<summary>{f.q}</summary>
						<p>{f.a}</p>
						{f.source && <small className="guided-faq__source">Source: {f.source}</small>}
					</details>
				))}
			</div>
		</div>
	);
}

export default JourneyFaqPanel;
